var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconScreenBold = function SvgIconScreenBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M19.83 20.48h-4.66a13.4 13.4 0 0 0-.264-2.65h4.925V6.17H4.17v.924a14 14 0 0 0-2.65-.263V6.17q0-1.108.77-1.88a2.56 2.56 0 0 1 1.88-.77h15.66q1.108 0 1.88.77.77.772.77 1.88v11.66q0 1.108-.77 1.88a2.56 2.56 0 0 1-1.88.77m-18.31 0v-3.226q1.343 0 2.285.941.94.942.94 2.285zm5.226 0q0-2.173-1.529-3.7-1.53-1.526-3.697-1.526v-2.211q3.108 0 5.273 2.165t2.165 5.272zm4.211 0a9.2 9.2 0 0 0-.74-3.675 9.6 9.6 0 0 0-2.024-2.998 9.6 9.6 0 0 0-2.997-2.024 9.2 9.2 0 0 0-3.676-.74V8.83q2.416 0 4.533.911a11.8 11.8 0 0 1 3.705 2.497 11.7 11.7 0 0 1 2.5 3.706q.912 2.123.912 4.535z"
  })));
};
export default SvgIconScreenBold;